import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "insure__wrapper mb-0"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cards_insured = _resolveComponent("cards-insured");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "insure__header"
  }, [_createElementVNode("h2", null, "Travel insurance as unique as you")], -1)), _createVNode(_component_cards_insured)]);
}